<mat-card appearance="outlined">
    <mat-card-content [formGroup]="formGroupZeit" class="no-title">
        <span class="row">
            <mat-form-field>
                <mat-label> {{ "MAIN_APP_SERVICE_APP.datum" | translate }}</mat-label>
                <input [formControlName]="fldDatumKey" [id]="fldDatumKey" [matDatepicker]="picker" matInput required/>
                <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>

            <ng-container *ngIf="this.useObjSearchByInput">
                <mat-form-field>
                    <mat-label>{{ "MAIN_APP_SERVICE_APP.auftrag" | translate }}</mat-label>
                    <input [formControlName]="fldAuftragKey" [matAutocomplete]="auto" aria-label="Number" matInput placeholder="Auftrag/Objekt" required type="text">
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" class="order-option-panel" (optionSelected)='onAuftragChange($event)'>
                        <mat-option *ngFor="let obj of filteredObjectSource | async" [value]="obj" class="order-option">
                            <span class="row">
                                {{ obj.viewValue }}
                                <mat-icon *ngIf="!obj.isPlanned">timer</mat-icon>
                            </span>
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
            </ng-container>

            <!-- Objektsuche per Auswahl -->
            <ng-container *ngIf="!this.useObjSearchByInput">
                <mat-form-field>
                    <mat-label>{{ "MAIN_APP_SERVICE_APP.auftrag" | translate }}</mat-label>
                    <mat-select [formControlName]="fldAuftragKey" [required]="true" panelClass="order-option-panel-select" (selectionChange)="onAuftragChange($event)">
                        <mat-option [disabled]="true" class="order-option">--
                            {{ "MAIN_APP_SERVICE_APP.auftragWählen" | translate }} --
                        </mat-option>
                        <mat-optgroup *ngFor="let group of (orderGroups | keyvalue)" [disabled]="group.value.disabled || false" [label]="group.value.name">
                            <mat-option *ngFor="let auftrag of group.value.auftraege" [value]="auftrag.value" class="order-option">
                                <span class="row">
                                    {{ auftrag.viewValue }}
                                    <mat-icon *ngIf="!auftrag.isPlanned">timer</mat-icon>
                                </span>
                            </mat-option>
                        </mat-optgroup>
                    </mat-select>
                </mat-form-field>
            </ng-container>


            <mat-form-field>
                <mat-label>{{ "MAIN_APP_SERVICE_APP.mitarbeiter" | translate }}</mat-label>
                <mat-select [formControlName]="fldMitarbeiterKey" [multiple]="true" [required]="true">
                    <mat-option *ngFor="let employee of dbMitarbeiter" [value]="employee.employeeID">{{ employee.firstName + " " + employee.lastName }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            </span>
        <span class="row">
			<!-- Objektsuche per Eingabe -->
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_SERVICE_APP.kostenstelle" | translate }}</mat-label>
				<mat-select (selectionChange)="kostenstelleChange($event.value)" [formControlName]="fldKostenstellenKey" [id]="fldKostenstellenKey" [required]="true">
					<mat-option *ngFor="let costCenter of dbKostenstellen" [value]="costCenter.costCenterID">
						{{ costCenter.costCenterID + " " + costCenter.description }}
					</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field>
				<mat-label>{{ "MAIN_APP_SERVICE_APP.tätigkeit" | translate }}</mat-label>
				<input [formControlName]="fldArbeitsbezeichnungKey" [id]="fldArbeitsbezeichnungKey" matInput required/>
			</mat-form-field>

			<span class="row">
				<mat-form-field>
					<mat-label> {{ lblArbeitsort }}</mat-label>
					<ng-container *ngIf="this.fldWorkplaceRequired">
						<input [formControlName]="fldArbeitsortKey" [id]="fldArbeitsortKey" matInput required/>
					</ng-container>
					<ng-container *ngIf="!this.fldWorkplaceRequired">
						<input [formControlName]="fldArbeitsortKey" [id]="fldArbeitsortKey" matInput/>
					</ng-container>
				</mat-form-field>
				<fa-icon (click)="setLocation()" [icon]="faSearchLocation" style="color: black;"></fa-icon>
			</span>

		</span>
        <span class="row">
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_SERVICE_APP.startzeit" | translate }}</mat-label>
				<input (blur)="onTimeChange($event)" [formControlName]="fldStartzeitKey" [id]="fldStartzeitKey" matInput type="time"/>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_SERVICE_APP.endzeit" | translate }}</mat-label>
				<input (blur)="onTimeChange($event)" [formControlName]="fldEndzeitKey" [id]="fldEndzeitKey" matInput type="time"/>
			</mat-form-field>
			<mat-form-field>
				<mat-label>{{ "MAIN_APP_SERVICE_APP.anzahlStunden" | translate }}</mat-label>
				<input (blur)="onNumberOfHoursChange($event)" [formControlName]="fldAnzStundenKey" [id]="fldAnzStundenKey" matInput required type="number"/>
			</mat-form-field>
		</span>

        <span class="row" style="align-items: flex-start;">
			<span class="column" style="width: 80%">
				<span class="row">
					<mat-form-field>
						<mat-label>{{ "MAIN_APP_SERVICE_APP.spesenart" | translate }}</mat-label>
						<mat-select (selectionChange)="spesenartChange($event.value)" [formControlName]="fldSpesenartKey" [id]="fldSpesenartKey">
							<mat-option *ngFor="let expense of dbSpesen" [value]="expense.expenseID">
								{{ expense.description }}
							</mat-option>
						</mat-select>
					</mat-form-field>

					<mat-form-field>
						<mat-label>{{ "MAIN_APP_SERVICE_APP.menge" | translate }}</mat-label>
						<input [formControlName]="fldSpesenMengeKey" [id]="fldSpesenMengeKey" matInput type="number"/>
					</mat-form-field>

					<mat-form-field>
						<mat-label>{{ "MAIN_APP_SERVICE_APP.einheit" | translate }}</mat-label>
						<input [formControlName]="fldSpesenEinheitKey" [id]="fldSpesenEinheitKey" matInput/>
					</mat-form-field>

					<mat-form-field>
						<mat-label>{{ "MAIN_APP_SERVICE_APP.preis" | translate }}</mat-label>
						<input [formControlName]="fldSpesenPreisKey" [id]="fldSpesenPreisKey" matInput type="number"/>
					</mat-form-field>

				</span>

				<span class="row">
					<mat-form-field>
						<mat-label>{{ "MAIN_APP_SERVICE_APP.notizen" | translate }}</mat-label>
						<input [formControlName]="fldNotizenKey" [id]="fldNotizenKey" matInput/>
					</mat-form-field>
				</span>
			</span>
			<span class="column" style="row-gap: 0.25em;  width: 20%">
				<mat-checkbox [formControlName]="fldKulanzKey" [id]="fldKulanzKey">
					{{ "MAIN_APP_SERVICE_APP.kulanz" | translate }}
				</mat-checkbox>
				<mat-checkbox [formControlName]="fldNachtschichtKey" [id]="fldNachtschichtKey">
					{{ "MAIN_APP_SERVICE_APP.nachtschicht" | translate }}
				</mat-checkbox>
				<mat-checkbox *ngIf="isVerrechnungsCheckboxEnabled" [formControlName]="fldVerrechnungKey" [id]="fldVerrechnungKey" class="cbInaktiv-margin">
					{{ "MAIN_APP_SERVICE_APP.verrechnung" | translate }}
				</mat-checkbox>
			</span>
		</span>
        <span class="row">
            <span>
                <mat-checkbox formControlName="disableUnplannedOrders" class="cbInaktiv-margin">{{ 'MAIN_APP_SERVICE_APP.DISABLE_SHOWING_UNPLANNED' | translate }}</mat-checkbox>
            </span>
            <span *ngIf="!(isOrderPlanned | async)" style="color: #fcba03">{{ 'MAIN_APP_SERVICE_APP.ORDER_NOT_PLANNED_TEXT' | translate }}</span>
        </span>
    </mat-card-content>

    <mat-dialog-actions>
        <button (click)="save()" [disabled]="formGroupZeit.invalid" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.save' | translate" class="confirm" mat-dialog-close mat-stroked-button></button>
        <button (click)="closeDialog()" [innerText]="'MAIN_APP_DIALOG.INPUT_DIALOG.cancel' | translate" class="cancel" mat-dialog-close mat-stroked-button></button>
    </mat-dialog-actions>
</mat-card>
